import styled, { css } from 'styled-components'
import palette from '../../../../theme/palette'
import { Paragraph } from '../../Typography/Typography.styles'

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SelectTrigger = styled.button<{
  $isOpen?: boolean
  $hasValue?: boolean
  $hasError?: boolean
  $disabled?: boolean
  colorScheme?: string
  withBackground?: boolean
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.rem(8)};
  height: ${({ theme }) => theme.rem(40)};
  padding: ${({ theme }) => theme.rem(0, 8)};
  border: none;
  border-bottom: 1px solid ${({ theme, $hasError }) => ($hasError ? theme.colors.status.error.default : palette.grayscale[200])};
  background-color: transparent;
  ${({ theme }) => theme.typo('buttonMD')};
  color: ${({ theme, colorScheme, withBackground, $hasValue }) => {
    if (!$hasValue) return palette.grayscale[400]
    return withBackground
      ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative
      : 'black'
  }};
  cursor: pointer;
  text-align: left;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}

  i {
    transition: transform 0.2s ease;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
    flex-shrink: 0;
  }
`

export const SelectDropdown = styled.div`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.rem(4)});
  left: 0;
  right: 0;
  z-index: 10;
  border-radius: ${({ theme }) => theme.rem(8)};
  background: ${palette.grayscale[50]};
  border: 1px solid ${palette.grayscale[100]};
  box-shadow: 0 2px 12px 0 rgba(0, 34, 33, 0.1);
  padding: ${({ theme }) => `${theme.rem(8)} 0`};
  max-height: ${({ theme }) => theme.rem(300)};
  overflow: auto;
`

export const SelectOption = styled.div<{ $isSelected?: boolean; $isActive?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.rem(10)};
  padding: ${({ theme }) => `${theme.rem(10)} ${theme.rem(16)}`};
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: ${({ theme }) => theme.rem(14)};
  color: ${palette.green[300]};
  text-align: left;
  transition: background 0.15s ease;
  user-select: none;

  &:hover {
    background: ${palette.grayscale[100]};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: ${palette.grayscale[100]};
    `}

  ${Paragraph} {
    color: ${palette.green[300]} !important;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      font-weight: 500;
    `}
`

export const SelectCheckmark = styled.span`
  display: flex;
  align-items: center;
  color: ${palette.green[300]};
  flex-shrink: 0;

  svg {
    width: ${({ theme }) => theme.rem(16)};
    height: ${({ theme }) => theme.rem(16)};
  }
`

export const SelectError = styled.div`
  padding-top: ${({ theme }) => theme.rem(8)};
  color: ${({ theme }) => theme.colors.status.error.default};
  font-size: ${({ theme }) => theme.rem(12)};
`

export const SelectHelperText = styled.div<{ colorScheme?: string, withBackground?: boolean }>`
  padding-top: ${({ theme }) => theme.rem(8)};
  font-size: ${({ theme }) => theme.rem(12)};
  color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
`
